
const Details = ({ title, value }) => {
    return (<div>
        <strong>{title}:</strong><p>{value}</p>
    </div>)
}

export default Details